// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__4Z9l6","row":"Node_row__2cUve","label":"Node_label__2M4nk","footer":"Node_footer__2Y5ef"};